import { intiAccordions } from "../components/landing/accordions";
import { initHeaderAnimations } from "../components/landing/header";
import { initLandingTestimonials } from "../components/landing/slider";

window.addEventListener('DOMContentLoaded', function () {
  intiAccordions();
  initLandingTestimonials();
  initHeaderAnimations();

}, { once: true });
